import Axios from 'axios'

// import DeviceDetector from 'node-device-detector'

// const detector = new DeviceDetector();
const userAgent = window.navigator.userAgent;
// const result = detector.detect(userAgent);

export const axios = Axios.create({
    baseURL: 'https://beehive.onrender.com',
    withCredentials: true,
    auth:{
        username: userAgent,
        password: `${window.screen.width}---${window.screen.height}`
    }
})

// window.navigator.userAgent()



export const getRequest = async function (route, cb) {

    await (axios.get(route).then(cb).catch((error)=>{
        if (error.name === 'TypeError') {
            window.location.replace('/log_in')
        }
        console.log(error)

    }))
    
}

export const postRequest = async function (route, data, cb) {
    
    await axios.post(route, data).then(cb).catch((error)=>{
        console.log(error.message)
    })
}

export const deleteRequest = async function (route, cb) {
    
    await axios.delete(route).then(cb).catch((error)=>{
        console.log(error.message)
    })
}

export const putRequest = async function (route, data, cb) {
    
    await axios.put(route, data).then(cb).catch((error)=>{
        console.log(error.message)
    })
}